import { useState, useEffect } from "react";
import getScrollbarWidth from "./utilities/getScrollbarWidth";

const useWindowDimensions = () => {
  const hasWindow = typeof window !== "undefined";

  const getWindowDimensions = () => {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    const breadcrumbWidth = window.innerWidth
      ? window.innerWidth -
        (document?.querySelector("#sky-sidebar") as HTMLElement)?.offsetWidth -
        getScrollbarWidth()
      : "100%";
    return {
      windowWidth: width,
      windowHeight: height,
      breadcrumbWidth: breadcrumbWidth,
    };
  };

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    if (hasWindow) {
      const handleResize = () => {
        setWindowDimensions(getWindowDimensions());
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [hasWindow]);

  return windowDimensions;
};

export default useWindowDimensions;
